import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import Ads from "../../../FO/components/ads/ads.component";
import SearchByTag from "../searchbytag/searchbytag.component";
import ModalReservation from "../modalreservation/modalreservation.component";
import { clearHallConfiguration } from "../../actions/movietheaters.actions";
import {LOGIN_ROUTE, EDIT_PROFILE_ROUTE} from "../../../SHARED/config/routes";
import {withRouter} from 'react-router';
import {redirectUrl} from '../../actions/filters.actions';
import {isEmpty} from '../../helpers/general.helper';
import moment from 'moment';

class SelectHours extends Component {

    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            nextStep: false,
            movieSchedule: []
        };

        this.openReservationModal = this.openReservationModal.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(this.props.movieSchedule !== nextProps.movieSchedule){
            this.setState({movieSchedule: nextProps.movieSchedule});
        }
        if (!isEmpty(this.props.clickedScheduleTicket) ){
            this.setState({openModal: true});
        }
    }

    openReservationModal = () => {
        if (this.props.isUserAuthenticated){
            this.setState({
                openModal: true,
            });
        } else {
            this.props.redirectUrl(this.props.history.location.pathname);
            this.props.history.push(LOGIN_ROUTE);
        }
    };

    toggle() {
        this.setState({
            openModal: !this.state.openModal,
            nextStep: false
        });
        this.props.clearHallConfiguration();
    }

    nextStep() {
        this.setState({
            nextStep: true
        });
    }

    goTo(url,cinemaName) {
        window.open(url, '_blank');
        window.gtag(
            'event','Visited another Website',{
            'event_category':'cinema_visit',
            'event_label':cinemaName,
        })
    }

    getConditionalButton = (item) => {
        if(item.cinema.cinema_ticket_sales === 1) {
            return <button className="access-movie cinema-name-button" onClick={this.openReservationModal}>Rezervă locuri</button>
        } else {
            return <button className="access-movie cinema-name-button" onClick={() => this.goTo(item.cinema.cinema_website,item.cinema.cinema_name)}>Cumpără bilete de la {item.cinema.cinema_name}</button>
        }
    };

    getContent = () => {
        if(this.props.movieSchedule.length !== 0){
            return this.props.movieSchedule.map((item, i) => {
                const currentHour = moment();
                let filteredHours = item.schedule_broadcast_hours.filter(hour => {
                    const momentHour = moment(this.props.selectedDate + ' ' + hour.schedule_broadcast_hour, 'YYYY.MM.DD HH:mm');
                    return momentHour.isAfter(currentHour)
                });
                item.schedule_broadcast_hours = filteredHours
                if (item.cinema && item.schedule_broadcast_hours.length > 0) {
                    return <div key={i}>
                        <p className="text-white">{item.cinema.cinema_name}</p>
                        <p className="grey-text">{item.schedule_dubbed_subtitled}</p>
                        <div className="hours-section">
                            <div className="row hours-wrapper">
                                {item.schedule_broadcast_hours.map((hour, j) => {
                                        return <div className="col-lg-3 pdd5" key={j}>                 
                                            <div className="item-hours clearfix">
                                                <span className="radius-item">{item.schedule_projection_format}</span>
                                                <span className="hour-item">{hour.schedule_broadcast_hour}</span>
                                            </div>
                                        </div>
                                    }
                                )}
                            </div>
                        </div>
                        { this.getConditionalButton(item) }
                    </div>
                } else {
                    return <p className="grey-text">Pe data selectată filmul nu ruleaza in cinematografele din {this.props.selectedLocality}</p>
                }
            });
        }
        else {
            return <p className="grey-text">Pe data selectată filmul nu ruleaza in cinematografele din {this.props.selectedLocality}</p>
        }
    }

    render() {
        return (
            <Fragment>
                <ModalReservation 
                    toggle={() => this.toggle()} 
                    openModal={this.state.openModal} 
                    className={"modalReservation"} 
                    movieSchedule= {this.state.movieSchedule}
                    processNexStep={() => this.nextStep()}
                    nextStep= {this.state.nextStep}
                    schedule= {this.props.clickedScheduleTicket}
                />

                {this.getContent()}
                <Ads
                    id="div-gpt-ad-1662463754517-0"
                    slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463754517-0'); googletag.pubads().refresh();});"
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    movieSchedule: state.movies.movieSchedule,
    selectedLocality: localStorage.getItem("cinema_location"),
    clickedScheduleTicket: state.errors.scheduleInteraction,
    userDetails: state.profile.userDetails,
    selectedDate: state.filters.reservetionSelectedDate
});
export default withRouter(connect(mapStateToProps, {clearHallConfiguration, redirectUrl})(SelectHours));


// WEBPACK FOOTER //
// ./src/SHARED/components/selecthours/selecthours.component.js